import React from 'react';
import MandatAnnulantTitreAnterieurComponent
  from '../../../../components/Mouvement/Panel/InformationsRattachement/MandatAnnulantTitreAnterieurComponent';
import InformationsRattachementPanel from '../InformationsRattachementPanel';

class MandatAnnulantTitreAnterieurPanel extends InformationsRattachementPanel {
  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <MandatAnnulantTitreAnterieurComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default MandatAnnulantTitreAnterieurPanel;
